import React, { useState } from "react";
import { fetchUserInfo, login as fetchLogin } from "../../api";
import { TextInput, Button } from '../../components/UI';
import { ForgotPasswordPage } from "./ForgotPassword/ForgotPasswordPage";
import Logo from "./logo";
import { useSelector } from "react-redux";
import { selectIsAnalyticsInitialized } from "../../store/userSlice";
import { selectDataSourceID } from "../../store/common-slice";
import { isDev } from "../../utils/is-dev";

import styles from './authPage.module.scss';

const EyeIcon = ({ visible }) => {
  return (
    visible
      ?
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" >
        <path d="M2.98388 8.625V8.628C2.96704 8.69151 2.93785 8.75109 2.89797 8.80331C2.85809 8.85553 2.80831 8.89938 2.75147 8.93235C2.69463 8.96532 2.63185 8.98676 2.56672 8.99546C2.50159 9.00415 2.43538 8.99991 2.37188 8.983C1.94088 8.869 2.01688 8.372 2.01688 8.372L2.03488 8.31C2.03488 8.31 2.06088 8.226 2.08188 8.165C2.33851 7.44549 2.71628 6.77516 3.19888 6.183C4.09588 5.089 5.60489 4 7.99989 4C10.3949 4 11.9039 5.089 12.8019 6.183C13.2845 6.77516 13.6623 7.44549 13.9189 8.165C13.9404 8.22684 13.9604 8.28919 13.9789 8.352L13.9819 8.365V8.369L13.9829 8.371C14.0146 8.49827 13.995 8.6329 13.9284 8.74588C13.8618 8.85886 13.7535 8.94114 13.6267 8.97498C13.5 9.00883 13.3651 8.99153 13.251 8.92681C13.1369 8.86209 13.0528 8.75513 13.0169 8.629L13.0159 8.625L13.0079 8.6C12.9512 8.42299 12.8844 8.24938 12.8079 8.08C12.6041 7.62678 12.3419 7.20217 12.0279 6.817C11.2859 5.912 10.0439 5 7.99989 5C5.95589 5 4.71488 5.912 3.97188 6.817C3.56439 7.31748 3.24484 7.88352 3.02688 8.491C3.01453 8.52711 3.00286 8.56345 2.99189 8.6L2.98388 8.625Z" fill="#7A7E89" />
        <path d="M5.5 9.5C5.5 8.83696 5.76339 8.20107 6.23223 7.73223C6.70107 7.26339 7.33696 7 8 7C8.66304 7 9.29893 7.26339 9.76777 7.73223C10.2366 8.20107 10.5 8.83696 10.5 9.5C10.5 10.163 10.2366 10.7989 9.76777 11.2678C9.29893 11.7366 8.66304 12 8 12C7.33696 12 6.70107 11.7366 6.23223 11.2678C5.76339 10.7989 5.5 10.163 5.5 9.5Z" fill="#7A7E89" />
      </svg>
      :
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M10.1206 10.8269L14.1466 14.8539C14.1931 14.9004 14.2483 14.9373 14.309 14.9624C14.3698 14.9876 14.4349 15.0005 14.5006 15.0005C14.5664 15.0005 14.6315 14.9876 14.6922 14.9624C14.753 14.9373 14.8081 14.9004 14.8546 14.8539C14.9011 14.8074 14.938 14.7522 14.9632 14.6915C14.9883 14.6307 15.0013 14.5656 15.0013 14.4999C15.0013 14.4342 14.9883 14.3691 14.9632 14.3083C14.938 14.2476 14.9011 14.1924 14.8546 14.1459L1.85463 1.1459C1.80814 1.09941 1.75295 1.06253 1.69222 1.03738C1.63148 1.01222 1.56638 0.999268 1.50063 0.999268C1.43489 0.999268 1.36979 1.01222 1.30905 1.03738C1.24831 1.06253 1.19312 1.09941 1.14663 1.1459C1.10014 1.19239 1.06327 1.24758 1.03811 1.30832C1.01295 1.36906 1 1.43416 1 1.4999C1 1.56564 1.01295 1.63074 1.03811 1.69148C1.06327 1.75222 1.10014 1.80741 1.14663 1.8539L4.37663 5.0839C3.93701 5.39532 3.54144 5.76466 3.20063 6.1819C2.71803 6.77406 2.34025 7.44439 2.08363 8.1639C2.06263 8.2249 2.03663 8.3089 2.03663 8.3089L2.01863 8.3709C2.01863 8.3709 1.94263 8.8679 2.37363 8.9819C2.50173 9.01576 2.63802 8.99739 2.75259 8.93082C2.86715 8.86426 2.95061 8.75495 2.98463 8.6269L2.98563 8.6239L2.99363 8.5989L3.02863 8.4899C3.24659 7.88242 3.56613 7.31638 3.97363 6.8159C4.29398 6.42216 4.6731 6.08015 5.09763 5.8019L6.67563 7.3799C6.35719 7.57949 6.08785 7.8483 5.88764 8.16634C5.68742 8.48438 5.56149 8.84347 5.5192 9.2169C5.47691 9.59032 5.51936 9.96848 5.64338 10.3232C5.7674 10.678 5.96981 11.0002 6.23555 11.266C6.5013 11.5317 6.82353 11.7341 7.17829 11.8582C7.53305 11.9822 7.91121 12.0246 8.28463 11.9823C8.65806 11.94 9.01715 11.8141 9.33519 11.6139C9.65323 11.4137 9.92205 11.1443 10.1216 10.8259L10.1206 10.8269ZM6.32063 4.1989L7.17463 5.0529C7.44852 5.01732 7.72444 4.99961 8.00063 4.9999C10.0446 4.9999 11.2866 5.9119 12.0286 6.8169C12.4362 7.31732 12.7558 7.88338 12.9736 8.4909C12.9906 8.5389 13.0016 8.5759 13.0086 8.5999L13.0166 8.6249V8.6279L13.0176 8.6289C13.0546 8.7537 13.1388 8.85915 13.2524 8.92284C13.3659 8.98653 13.4998 9.00343 13.6256 8.96997C13.7513 8.9365 13.8591 8.8553 13.926 8.74362C13.9929 8.63194 14.0135 8.49858 13.9836 8.3719V8.3689L13.9826 8.3649L13.9786 8.3519C13.9613 8.28874 13.9413 8.22635 13.9186 8.1649C13.662 7.44539 13.2842 6.77506 12.8016 6.1829C11.9056 5.0879 10.3966 3.9999 8.00263 3.9999C7.38463 3.9999 6.82563 4.0719 6.32163 4.1989H6.32063Z" fill="#7A7E89" />
      </svg>
  )
};

export const AuthPage = () => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(true);

  const [inputType, setInputType] = useState("password");
  const [error, setError] = useState('');
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [isInvalidCredentials, setIsInvalidCredentials] = useState(false);
  const [hasForgottenPassword, setHasForgottenPassword] = useState(false);

  const { location, localStorage } = window;
  localStorage.setItem('userToken', "");
  const redirectedFrom = localStorage.getItem('redirectedFrom');

  const switchShowPass = () => {
    if (isPasswordVisible) {
      setInputType('text');
    }
    else {
      setInputType('password');
    }
    setIsPasswordVisible(!isPasswordVisible)
  }

  const buttonToggle = (
    <button className={styles.btnPass} onClick={switchShowPass}>
      <EyeIcon visible={isPasswordVisible} />
    </button>
  );

  const validate = () => {
    if (login && password) {
      setError('');
    }
    else {
      setError('Please enter login and password');
    }

    setIsInvalidCredentials(false);
  }

  const handleSubmit = async () => {
    if (login && password) {
      let response;
      try {
        response = await fetchLogin(login, password);
      }
      catch (error) {
        setError('Invalid login and/or password');
        setIsInvalidCredentials(true);
        return;
      }

      if (response.message) {
        setError(response.message);
        setIsInvalidCredentials(true);
      }

      if (response) {
        const userInfo = await fetchUserInfo();
        const { tenantId, tenant, id } = userInfo.value;

        /*eslint-disable*/
        await merlin.send({
          event_name: 'user_login',
          event_type: 'login',

          auth_project: {
            tenant_id: tenantId,
            tenant_name: "Merlin",
            api_key: isDev() ? 'QW93DLs6z39geUZmdpp6' : 'DiZZapAbJ6iydj21VHAJ'
          },

          user_ids: {
            user_id: id,
            wallet_address: id
          },
          user_properties: {
            tenantName: tenant
          }
        });

        if (response.token) {
          if (!redirectedFrom) {
            location.href = `/settings`;
          }
          else {
            location.href = redirectedFrom;
            localStorage.setItem('redirectedFrom', '');
          }
        }
      }
    }
    validate(login, password);
  }

  return (
    hasForgottenPassword
      ?
      <ForgotPasswordPage
        onBackToLogin={() => setHasForgottenPassword(false)}
      />
      :
      <div className={styles.authPage}>
        <div className={styles.wrapper}>
          <Logo />

          <div className={styles.content}>
            <h1>
              Log into Merlin
            </h1>

            <h2>
              Don't have credentials? Request for access <a href="https://www.getmerlin.xyz/form">here</a>
            </h2>

            <div className={styles.inputsContainer}>
              <TextInput
                className={styles.username}
                value={login}
                placeholder="Username"
                onChange={login => {
                  setLogin(login);
                  setError('');
                }}
                status={error && login.length === 0 ? 'error' : ''}
              />
              <TextInput
                value={password}
                inputType={inputType}
                placeholder="Password"
                status={error && password.length === 0 ? 'error' : ''}
                iconRight={buttonToggle}
                onChange={password => {
                  setPassword(password);
                  setError('');
                }}
              />

              {error &&
                <p className={styles.error}>{error}</p>
              }
            </div>

            <Button
              hasHoverStars={true}
              onClick={handleSubmit}
            >
              Get early access

              <div className={styles.star}>
                <svg width="20" height="20" viewBox="0 0 11 11" fill="none">
                  <path d='M5.5 0L5.84323 4.15116C5.88754 4.68712 6.31288 5.11246 6.84884 5.15677L11 5.5L6.84884 5.84323C6.31288 5.88754 5.88754 6.31288 5.84323 6.84884L5.5 11L5.15677 6.84884C5.11246 6.31288 4.68712 5.88754 4.15116 5.84323L0 5.5L4.15116 5.15677C4.68712 5.11246 5.11246 4.68712 5.15677 4.15116L5.5 0Z' fill='#3736FF' />
                </svg>
              </div>
            </Button>

            <button
              className={styles.forgotButton}
              onClick={() => setHasForgottenPassword(true)}
            >
              Forgot password?
            </button>

            {isInvalidCredentials &&
              <p className={styles.errorFormText}>
                Invalid credentials, please retry.
                If you still face an error, send an email at
                {' '}
                <a href="mailto:hello@getmerlin.xyz">hello@getmerlin.xyz</a>
              </p>
            }
          </div>
        </div>
      </div>
  )
}